// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5f2abb2e","952":"a43d2e92"}[chunkId] + ".chunk.js";
};